import { render, staticRenderFns } from "./DashboardCard.vue?vue&type=template&id=ee5d3bd8&scoped=true&"
import script from "./DashboardCard.vue?vue&type=script&lang=js&"
export * from "./DashboardCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCard.vue?vue&type=style&index=0&id=ee5d3bd8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5d3bd8",
  null
  
)

export default component.exports